module.exports = __webpack_public_path__ + "img/logo.eb73bf7f.svg";